import { WebLinkType } from '../../model/types';

export const WEB_LINKS_LABELS_MAP: Record<WebLinkType, string> = {
  [WebLinkType.webFunnel]: 'Web Funnel',
  [WebLinkType.web2App]: 'Web2App',
};

export const WEB_LINKS_DESCRIPTIONS_MAP: Record<WebLinkType, string> = {
  [WebLinkType.webFunnel]:
    'A series of web pages designed to guide users toward a specific action (e.g., onboarding → sign up → purchase → access the product). Monetization happens on the web (via Stripe, PayPal, etc.). Sometimes referred to as Web2Web.',
  [WebLinkType.web2App]:
    'A strategy to convert web users into app users, encouraging them to install and engage with the mobile app. Monetization happens in the app (via Apple, Google, etc.).',
};
